<template>
  <footer>
    <article>
      <div class="text_box">
        <div class="text_box_1">
          <img src="@/assets/img/giupnuri_logo_white.png"/>
          <p>
            브랜드명 : 기업누리<br/>
            상호 : (주)강소기업개발진흥원<br/>
            주소 : 대전광역시 유성구 은구비남로7번길 19 거성빌딩3층<br/>
            사업자등록번호 : 384-87-02533<br/>
            전화 : <a href="tel:1588-9138">1588-9138</a><br/>
            문의메일 : <a href="mailto:kangsogood@naver.com">kangsogood@naver.com</a>
          </p>
        </div>
        <!--          <div class="text_box_2">-->
        <!--            <h1>-->
        <!--              메뉴-->
        <!--            </h1>-->
        <!--            <ul>-->
        <!--              <li>-->
        <!--                서비스 문의-->
        <!--              </li>-->
        <!--              <li>-->
        <!--                고객사례-->
        <!--              </li>-->
        <!--              <li>-->
        <!--                제품소개-->
        <!--              </li>-->
        <!--            </ul>-->
        <!--          </div>-->
        <div class="text_box_3">
          <ul>
            <li>
              <img src="@/assets/img/google.png" alt="구글">
            </li>
            <li>
              <img src="@/assets/img/naver-icon.png" alt="네이버">
            </li>
            <li>
              <img src="@/assets/img/kakao-icon.png" alt="카카오톡">
            </li>
            <li>
              <img src="@/assets/img/daum-icon.png" alt="다음">
            </li>
            <li>
              <img src="@/assets/img/insta-icon.png" alt="인스타그램">
            </li>
          </ul>
        </div>
      </div>
    </article>
  </footer>
</template>
<script>
export default {
  name: 'layout-footer'
}
</script>
<style lang="css" scoped>
footer {
  background-color: #131E34;
  margin-top: 4rem;
  padding: 2.5rem 0;
}

footer article {
  width: 1200px;
  margin-right: auto;
  margin-left: auto;
}

.text_box {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.text_box_1 h1 {
  color: #fff;
  font-weight: bold;
  font-size: 22px;
}

.text_box_1 p {
  font-size: 14px;
  line-height: 26px;
  text-align: left;
  margin-top: 1rem;
  color: #4F5A70;
}

.text_box_2 {
  margin-top: 1rem;
}

.text_box_2 h1 {
  color: #fff;
  font-weight: bold;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: -0.0551724px;
}

.text_box_2 ul {
  line-height: 41px;
  font-size: 14px;
  margin-top: 1rem;
}

.text_box_2 ul li {
  color: #4F5A70;
}

.text_box_3 {
  margin-bottom: 7rem;
}

.text_box_3 ul {
  flex-direction: row;
  display: flex;
}

.text_box_3 ul li {
  background-color: #4F5A70;
  text-align: center;
  border-radius: 100%;
  width: 2rem;
  height: 2rem;
  margin-right: 1rem;
  cursor: pointer;
}

.text_box_3 ul li img {
  display: inline;
  margin-top: 0.5rem;
}
</style>
